<template>
  <div class="settings-card">
    <div
        v-if="tooltip.visible"
        class="momentum-tooltip"
        :style="{ left: tooltip.x + 'px', top: tooltip.y + 'px' }"
    >
      {{ tooltip.text }}
    </div>
    <!-- Odds type -->
    <div class="setting-group" :title="$t('oddsType')">

      <div class="setting-label" >{{ $t('oddsType') }}:</div>
      <div class="select-wrap">
        <select v-model="oddsType" class="select">
          <option
              v-for="type in oddsTypes"
              :key="type.value"
              :value="type.value"
          >
            {{ $t(type.label) }}
          </option>
        </select>
        <svg class="select-chevron" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </div>
    </div>

    <!-- Accept odds -->
    <div
      class="setting-group"
      v-if="showAcceptOdds"
    >

      <div class="setting-label" @mouseenter="showTooltip($event, acceptOdds ? $t('acceptAnyOdds') : $t('alwaysAsk'))" @mousemove="updateTooltipPos" @mouseleave="hideTooltip" >{{ acceptOdds ? $t('acceptOddsShort') : $t('alwaysAskShort') }}</div>
      <label class="switch">
        <input type="checkbox" v-model="acceptOdds">
        <span class="slider"></span>
      </label>
    </div>

    <!-- Theme toggle -->
    <div class="setting-group" @click="toggleTheme" style="cursor:pointer;" v-if="getChooseThemeMode">
      <svg v-if="isLight" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="5"/>
        <line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
        <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
      </svg>
      <svg v-else width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
      </svg>
    </div>



  </div>
</template>


<script>

import {mapGetters} from "vuex";

export default {

  name: "ToolbarSettings",
  props: {
    showAcceptOdds: {
      type: Boolean,
      default: true
    }
  },

  data(){
    return {
      tooltip: { visible: false, text: '', x: 0, y: 0 }
    }
  },
  methods:{
    toggleTheme() {
      const next = this.isLight ? 'dark' : 'light';
      // Applied to Vuetify and to <html class="light"> by installThemeSync
      this.$store.commit('settings/SET_THEME', next);
    },
    showTooltip(e, text) {
      this.tooltip.text = text;
      this.tooltip.visible = true;
      this.tooltip.x = e.clientX - 150;
      this.tooltip.y = e.clientY + 15;
    },
    updateTooltipPos(e) {
      if (this.tooltip.visible) {
        this.tooltip.x = e.clientX - 150;
        this.tooltip.y = e.clientY + 15;
      }
    },
    hideTooltip() {
      this.tooltip.visible = false;
    },
  },

  computed: {

    ...mapGetters({
      'getChooseThemeMode': 'settings/getChooseThemeMode',
      'getTheme': 'settings/getTheme',
    }),

    isLight() {
      return this.getTheme === 'light';
    },

    oddsTypes() {
      const supported = this.$store.state.odds.supportedOddsFormats;
      if (supported && supported.length > 0) {
        return supported.map(f => typeof f === 'string' ? { label: f, value: f } : f);
      }
      const current = this.$store.state.odds.odds_type;
      return [{ label: current, value: current }];
    },

    acceptOdds: {
      get(){
        return this.$store.state.cart.odds_variation
      },
      set(value){
        this.$store.commit("cart/SET_ODDS_VARIATION", value)
      }
    },

    oddsType:{
      get(){
        return this.$store.state.odds.odds_type
      },
      set(value){
        this.$store.commit("odds/SET_ODDS_TYPE", value)
      }
    }

  }

}
</script>

<style scoped>

.settings-card {
  color: var(--text-platform);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  gap: 16px;
  white-space: nowrap;
}

.setting-group {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: default;
}

.setting-label {
  font-size: var(--font-size-xl);
  color: var(--text-op-50-platform);
}

/* SELECT */

.select-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.select {
  appearance: none;
  -webkit-appearance: none;
  border-radius: 8px;
  color: var(--text-platform);
  font-size: var(--font-size-xl);
  outline: none;
  cursor: pointer;
  transition: 0.2s;
  text-decoration: underline;
  padding-right: 14px;
  background: transparent;
  border: none;
}

.select option {
  background: var(--bg-card, #1e2130);
  color: var(--text-platform, #ffffff);
  padding: 4px 6px;
}

.select:hover {
  border-color: var(--color-accent);
}

.select-chevron {
  position: absolute;
  right: 0;
  color: var(--text-op-50-platform);
  pointer-events: none;
}

/* SWITCH */

.switch {
  position: relative;
  width: 32px;
  height: 17px;
  flex-shrink: 0;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background: #444;
  border-radius: 20px;
  transition: 0.2s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 11px;
  width: 11px;
  left: 3px;
  bottom: 3px;
  background: white;
  border-radius: 50%;
  transition: 0.2s;
}

input:checked + .slider {
  background: var(--color-accent);
}

input:checked + .slider:before {
  transform: translateX(15px);
}

.momentum-tooltip {

  position: fixed;
  background: var(--bg-card-hover);
  color: var(--text-platform);
  padding: 6px 10px!important;
  border-radius: 4px;
  font-size: var(--font-size-2xl);
  white-space: nowrap;
  z-index: 9999;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);

}


</style>
